export class CombinedLogger {
    constructor(loggers) {
        this.loggers = loggers;
    }
    logInformation(message) {
        for (const logger of this.loggers) {
            logger.logInformation(message);
        }
    }
    logWarning(message) {
        for (const logger of this.loggers) {
            logger.logWarning(message);
        }
    }
    logError(message) {
        for (const logger of this.loggers) {
            logger.logError(message);
        }
    }
}
